<template>
  <div class="motion-props-v2" v-if="hasMotion" style="margin-left:5px; margin-right:5px;">
    <at-card v-for="(motion,index) of motions" :key="index" style="width: 100%; margin-bottom:10px" :no-hover="true">
        <h5 class="left-align" slot="title">{{getName(motion.TYPE)}}</h5>
        <div slot="extra"><i class="icon icon-x clickable" @click="delMotion(motion.TYPE)" ></i></div>
        <div class="left-align">
          <div class="option-row">
            
            <span class="">Loop</span>
            <at-radio-group class="pitem more-left right-end" v-model="loops[index]" fill="#526780" v-on:radio-group-change="selChange(motion.TYPE, 'loop', index)">
                <at-radio-button label="false">Once</at-radio-button>
                <at-radio-button label="true">&infin;</at-radio-button>
            </at-radio-group>

          </div>
          <div class="option-row">

            <span class="">Ease In</span>
            <at-radio-group class="pitem more-left right-end" v-model="easeIn[index]" fill="#526780" v-on:radio-group-change="selChange(motion.TYPE, 'easeIn', index)" >
                <at-radio-button label="true">On</at-radio-button>
                <at-radio-button label="false">Off</at-radio-button>
            </at-radio-group>

          </div>
          <div class="option-row">

            <span class="">Ease Out</span>
            <at-radio-group class="pitem more-left right-end" v-model="easeOut[index]" fill="#526780" v-on:radio-group-change="selChange(motion.TYPE, 'easeOut', index)" >
                <at-radio-button label="true">On</at-radio-button>
                <at-radio-button label="false">Off</at-radio-button>
            </at-radio-group>
            
          </div>
        </div>
    </at-card>

      <!--<at-timeline v-if="hasMotion">
            <at-timeline-item v-for="kf of keyFrames" :key="kf.frame" color="blue">
                <at-card style="width: 95%;" :no-hover="true">
                    <h5 class="left-align" slot="title">Frame {{kf.frame}}</h5>
                    <div slot="extra"><i class="icon icon-x clickable"></i></div>
                    <div class="left-align highlight" v-for="(prop, propertyName) in kf.motions" :key="propertyName">
                        <div style="padding:4px">
                            <div style="margin-right:24px" class="inline" v-for="(value, propertyName) in prop" :key="propertyName" >
                                {{propertyName}} : {{value}}
                            </div>
                            
                            <i class="icon icon-x clickable right-end"></i>
                        </div>
                    </div>
                </at-card>
            </at-timeline-item>
      </at-timeline>-->
      <!--<at-timeline v-if="!hasMotion">
            <at-timeline-item v-for="kf of kfs" :key="kf.frame" color="blue">
                <at-card style="width: 95%;" :no-hover="true">
                    <h5 class="left-align" slot="title">Frame {{kf.frame}}</h5>
                    <div slot="extra"><i class="icon icon-x clickable"></i></div>
                    <div class="left-align highlight" v-for="(motion, index) in kf.motions" :key="index">
                        <div style="padding:4px">
                            <div style="margin-right:24px" class="inline" v-for="(value, propertyName) in motion.vals" :key="propertyName">
                                {{propertyName}} : {{value}}
                            </div>
                            
                            <i class="icon icon-x clickable right-end"></i>
                        </div>
                    </div>
                </at-card>
            </at-timeline-item>
      </at-timeline>-->
      <!--
      <at-timeline v-if="hasMotion">
            <at-timeline-item v-for="(item, index) of keyFrames" :key="index" color="blue">
                <at-card style="width: 95%;" :no-hover="true">
                    <h5 class="left-align" slot="title">Frame {{item[0]}}</h5>
                    <div slot="extra"><i style="color:grey" class="icon icon-x clickable"></i></div>
                    <div class="left-align highlight" v-for="(rec,index) of item[1]" :key="index">
                        <div style="padding:4px">
                            <div style="margin-right:24px" class="inline" v-for="(value, name, index) in rec.vals" :key="index">
                                <span style="color:grey"> {{name}} : </span> <b> {{value}} </b>
                            </div>
                            
                            <i class="icon icon-x clickable right-end"></i>
                        </div>
                    </div>
                </at-card>
            </at-timeline-item>
      </at-timeline>
      -->
  </div>
</template>

<script>
import { UIUpdate } from '../../lib/bezieLib/UI/UIUpdate';
import { BObject } from '../../lib/bezieLib/Objects/BObject';
import { UIEvents } from '../../lib/bezieLib/UI/UIEvents';
import { Scene } from '../../lib/bezieLib/Scene';
import { BMotionType, BMotionEnums } from '../../lib/bezieLib/Animations/BMotionEnums';
import { BMotion2 } from '../../lib/bezieLib/Animations/BMotion2';
import { BMotionLabel } from '../../lib/bezieLib/BMotionCharacterisitics/BMotionLabels';

export default {
  name: 'MotionPropsV2',
  components: {
  },
  props: {
    bObject : BObject, 
    bScene : Scene
  },
  data: function(){
    return {
      hasMotion: true,
      motions: [],
      loops : [],
      easeIn: [],
      easeOut: []
    }
  },
  watch: {
    bObject: function(newObj){
      if(newObj){
        this.init();
      }
    }
  },
  methods: {
    updateModels(){
      for(var index in this.motions){
        this.loops[index] = this.motions[index].loop.toString()
        this.easeIn[index] = this.motions[index].easeIn.toString()
        this.easeOut[index] = this.motions[index].easeOut.toString()
      }
    },
    updateModel(index, type){
      var motion = this.bObject.getMotion(type);
      this.loops[index] = motion.loop.toString();
      this.easeIn[index] = motion.easeIn.toString();
      this.easeOut[index] = motion.easeOut.toString();
    },
    getName: function(type){
      return BMotionEnums.getBMotionName(type);
    },
    delMotion: function(type){
      this.bObject.deleteMotion(type);
    },
    selChange: function(motionType, optionType, index){
      //console.log(motionType+" "+optionType+" "+index);
      var boolVal = false
      switch(optionType){
        case "loop":
            boolVal = this.loops[index]=="true"? true : false
            this.bObject.updateMotion(motionType, BMotionLabel.LOOP, boolVal);
          break;
        case "easeIn":
            boolVal = this.easeIn[index]=="true"? true : false
            this.bObject.updateMotion(motionType, BMotionLabel.EASEIN, boolVal);
          break;
        case "easeOut":
            boolVal = this.easeOut[index]=="true"? true : false
            this.bObject.updateMotion(motionType, BMotionLabel.EASEOUT, boolVal);
          break;
      }
      this.updateModel(index,motionType);
    },/*
    format: function(val){
        var val = JSON.stringify(val);
        val = val.replace('{','');
        val = val.replace('}','');
        val = val.replace(/"/g,'');
        val = val.replace(':','');
        val = val.replace(',','');
        console.log("last "+val);
        return this.val;
    },
    constructFrameViewModel(){
        var motions = this.bObject.getMotions();
        var kfs = this.getFrames(motions);
        var kfobj = this.getKFObj(kfs);
        var kfobjWithRecs = this.addRecords(kfobj, motions);
        var sorted = this.sortRecords(kfobjWithRecs);
        this.keyFrames = Array.from(sorted);
        console.log(this.keyFrames);
    },
    sortRecords(toSort){
      for(var [key,value] of toSort){
        value.sort((a,b)=>a.type - b.type);
      }
      return toSort;
    },
    addRecords(kfobj, motions){
      for(var motion of motions){
            if(motion.canAnimate()){
              for(var kf of motion.keyFrames){
                var values = this.getVals(kf, motion.TYPE)
                //console.log(values);
                var rec = {
                    type : motion.TYPE,
                    vals : values
                  };
                console.log(kfobj.get(kf.frame))
                kfobj.get(kf.frame).push(rec);
              }
            }
        }
      return kfobj;
    },
    getVals(kf, type){
      var val = {};
      switch(type){
        case BMotionType.TRANS:
          val["X"] = kf.point[0];
          val["Y"] = kf.point[1];
          break;
        case BMotionType.SCALE:
          val["W"] = kf.scaleFactor[0];
          val["H"] = kf.scaleFactor[1];
          break;
        case BMotionType.ROTA:
          val["Angle"] = kf.angle;
          break;
        case BMotionType.FADE:
          val["Opacity"] = kf.opacity
          break;
      }
      return val;
    },
    getKFObj(kfs){
      var kfobj = new Map();
      for(var kf of kfs){
        kfobj.set(kf, [])
      }
      return kfobj
    },
    getFrames(motions){
      var frameSet = new Set()
        for(var motion of motions){
            if(motion.canAnimate()){
              for(var kf of motion.keyFrames){
                frameSet.add(kf.frame)
              }
            }
        }
        var frames = Array.from(frameSet)
        frames.sort((a,b)=>a-b)
        return frames
    },*/
    onUpdate : function(obj){
        //console.log("on update called");
        if(obj) {
            this.init();
        }
    },
    init: function(){
        if(this.bObject){
            if(this.bObject.isMotionObject()){
                if(this.bObject.hasMotions()){
                  //this.constructFrameViewModel();
                  this.motions = this.bObject.getMotions();
                  this.updateModels();
                  this.hasMotion = true;
                }
            }else{
                this.hasMotion = false;
            }
        }

    }
  },
  mounted: function(){
      if(this.bObject){
        this.init();
        UIUpdate.addObjectUpdateListener(this);
      } 
  },
  beforeDestroy: function(){
    if(this.bObject){
      UIUpdate.removeObjectUpdateListener(this);
    }
  }
}
</script>

<style>
.highlight:hover{
    background-color: whitesmoke;
    border-radius: 4px;
}

.option-row{
  padding: 2px;
  height: 36px;
}

.right-end{
    float: right;
}

.heading{
  font-size: 20px;
}

.is-changeable-text{
  cursor: text;
}

.section{
  font-size: 16px;
}

.inline{
  display: inline-block;
}

.left-align{
    text-align: left;
}

.right-align{
    text-align: right;
}

.pitem{
  vertical-align: middle;
}

.vspace{
  height: 8px;
  width: 100%;
}

.vspace-2{
  height: 4px;
  width: 100%;
}

.left{
  margin-left: 10px;
}

.more-left{
  margin-left: 20px;
}

.right{
  margin-right: 10px;
}

.is-std-width{
  width: 140px;
}

.is-std-width-2{
  width: 120px;
}

.is-std-width-4{
  width: 80px;
}

.small-width-2{
  width: 20px;
}

.small-width-4{
  width: 40px;
}

.small-width-6{
  width: 60px;
}

.small-width-8{
  width: 80px;
}

.small-width-10{
  width: 100px;
}

.clickable{
  cursor: pointer;
}

</style>